import type {DiscoveryNavLinkView} from "@repo/sanity-utils/discoveryChrome";

export const CAMPUS_ID_TOKEN = "{{campus_id}}";

/**
 * Campus chosen in the location selector wins. Otherwise use the campus
 * resolved on the server from the cookie, then the account.
 */
export function campusIdForAccountMenu(
	selectedCampusId: string | null | undefined,
	serverCampusId: string | null | undefined
): string | null {
	const selected = selectedCampusId?.trim() ?? "";
	if (selected) return selected;
	const server = serverCampusId?.trim() ?? "";
	return server || null;
}

/**
 * Replaces `{{campus_id}}` in logged-in account-menu hrefs. Links that still
 * need a campus after resolution are dropped so the menu never renders a
 * broken host.
 */
export function resolveAccountMenuLinks(
	links: DiscoveryNavLinkView[],
	campusId: string | null | undefined
): DiscoveryNavLinkView[] {
	const campus = campusId?.trim() ?? "";
	const resolved: DiscoveryNavLinkView[] = [];
	for (const link of links) {
		if (!link.href.includes(CAMPUS_ID_TOKEN)) {
			resolved.push(link);
			continue;
		}
		if (!campus) continue;
		resolved.push({
			...link,
			href: link.href.replaceAll(CAMPUS_ID_TOKEN, encodeURIComponent(campus)),
		});
	}
	return resolved;
}
